import { CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { MainPresenter } from 'src/main/Main.presenter'
import PJKeys from './pj.keys'
import PJScope, { HeaderScope } from './pj.scopes'
import pjService from './pj.service'

const LOG = Logger.get('PJPresenter')

export class PJPresenter extends CubePresenter<MainPresenter, PJScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, PJPresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new PJScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new PJKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        keys.parentSlot(this.scope)

        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.action(this.handleFind)
    }

    private async handleFind() {
        try {
            if (this.scope.cnpjSelected.length !== 14) {
                this.alert('error', 'CNPJ inválido', 'O CNPJ informado é inválido. Verifique e tente novamente.')
                return
            }
            const company = await pjService.fetchCompanyInfo(this.scope.cnpjSelected)
            this.scope.company = [company]
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        }
    }
}

export default PJPresenter
